import { createSlice } from "@reduxjs/toolkit";

const criteriaCatalogSlice = createSlice({
  name: "criteriaCatalog",
  initialState: [],
  reducers: {
    criteriaCatalogAdded(state, action) {
      return action.payload;
    },
    specificCriteriaCatalogAdded(state, action) {
      const catalog = action.payload;
      const catalogIndex = state.findIndex(item => item.id === catalog.id);
      if (catalogIndex !== -1) {
        state[catalogIndex] = catalog;
      }
    },
  },
});

export const { criteriaCatalogAdded, specificCriteriaCatalogAdded } = criteriaCatalogSlice.actions;
export default criteriaCatalogSlice.reducer;
